import React, { FC, PropsWithChildren } from 'react';
import { theme } from '@factorin/container.macro';

import { ClassName, cn } from 'Modules/ui';

import styles from './index.module.scss';


export interface FactorinWindowProps extends PropsWithChildren<ClassName> {
    overrideFill?: boolean;
}

export const FactorinWindow: FC<FactorinWindowProps> = ({
    className, children, overrideFill = true,
}) => (
    <div className={cn(
        styles.window,
        'hcenter vcenter',
        overrideFill && styles.fillGray,
        className,
    )}
    >
        <theme.logo.Normal />
        {children}
    </div>
);
